import { Component, OnInit } from '@angular/core';
import { UploadFile, UploadXHRArgs } from 'ng-zorro-antd';
import { HttpRequestService } from 'src/app/services/http-request.service';
import { HttpResult } from 'src/app/models/Commons/HttpResult';
import { PopWindow } from '../popwindow/popwindow.component';
import { Observable } from 'rxjs';
import { AppSettingService } from 'src/app/services/app-setting.service';
import { PromptService } from 'src/app/services/prompt.service';

@Component({
  selector: 'app-upload-picture',
  templateUrl: './upload-picture.component.html',
  styleUrls: ['./upload-picture.component.css']
})
export class UploadPictureComponent extends PopWindow implements OnInit {
  ngOnInit(): void {
    this.httpRequestService.httpRequest("PictureAction", "QueryPictureByOrderId", {
      pictureRelationType: this.pageParams.RelationType,
      orderId: this.pageParams.RelationOrderId
    }).subscribe((result: HttpResult<any>) => {
      this.alreadyUploadInfo = {};
      this.fileList = [];
      for (var i in result.data) {
        this.alreadyUploadInfo[result.data[i].PictureId] = result.data[i];
        this.fileList.push({
          uid: result.data[i].PictureId,
          name: result.data[i].PictureName,
          status: 'done',
          url: this.httpConfigService.getFileUrl(result.data[i].PicturePath)
        })
      }
    })
  }

  constructor(private httpRequestService: HttpRequestService,
    private httpConfigService: AppSettingService,
    private promptService: PromptService) {
    super();
  }

  showUploadList = {
    showPreviewIcon: true,
    showRemoveIcon: true,
    hidePreviewIconInNonImage: true
  };
  fileList = [];
  alreadyUploadInfo = {};
  previewImage: string | undefined = '';
  previewVisible = false;

  handlePreview = (file: UploadFile) => {
    this.previewImage = file.url || file.thumbUrl;
    this.previewVisible = true;
  };

  handleUpload = (item: UploadXHRArgs) => {
    return this.httpRequestService.uploadFile("PictureAction", "UploadFile", item.file, {
      "pictureInfo": this.pageParams
    }).subscribe((result: HttpResult<any>) => {
      if (result.code == 0) {
        this.alreadyUploadInfo[item.file.uid] = result.data;
        item.onSuccess(0, item.file, null);
      }
    }, error => {
      item.onError(error, item.file);
    });
  }

  handleRemove = (item: UploadFile) => {
    return new Observable((observer) => {
      const successHandler = (e) => observer.next(e);
      const errorHandler = (e) => observer.error(e);
      var uploadItem = this.alreadyUploadInfo[item.uid];
      this.httpRequestService.httpRequest("PictureAction", "DeletePicture", {
        pictureId: uploadItem.PictureId
      }).subscribe((result: HttpResult<any>) => {
        if (result.code == 0) {
          successHandler("删除成功");
        } else {
          errorHandler("删除失败");
        }
      })
    });
  }

  public doComplete() {
    this.httpRequestService.httpRequest("PictureAction", "ChangeOrderStatus", {
      pictureRelationType: this.pageParams.RelationType,
      orderId: this.pageParams.RelationOrderId
    }).subscribe((result: HttpResult<any>) => {
      if (result.code == 0) {
        this.promptService.success("凭证提交成功").subscribe(() => {
          this.closePopwindow();
        });
      }
      else
        this.promptService.error("凭证提交失败").subscribe();
    })
  }
}
